export const editableExtensions = [
  'odt', 'docx', 'doc', 'rtf',
  'ods', 'xlsx', 'xls', 'xlsm', 'csv',
  'odp', 'ppt', 'pptx',
  'odg', 'vsd', 'vsdx'
];

export const extToAnalysis = [ 'docx', 'pdf' ];

export const convertableTypesFiles = ['docx', 'doc', 'odt', 'txt', 'rtf', 'xls', 'xlsx', 'csv', 'ppt', 'pptx'];

export const typesToSigning = ['docx', 'doc', 'pdf', 'odt'];
export const typesWithoutVersions = ['folder'];

export const imageExtensions = ['jpeg', 'jpg', 'png', 'gif', 'bmp', 'jfif'];
export const videoExtensions = ['mp4', 'mov', 'webm', 'ogg', 'mkv'];
export const audioExtensions = ['mp3', 'aac', 'flac', 'wav', 'm4a'];
